import { ID, IDPrefixes } from '@griply/types';

const SEPARATOR = ':';

export const createCompositeId = (prefix: IDPrefixes, parts: ID[]): ID =>
  [prefix, ...parts].join(SEPARATOR);

export const getCompositeIdParts = (
  id: ID,
  expected: IDPrefixes,
): ID[] | null => {
  const [prefix, ...parts] = id.split(SEPARATOR);
  return prefix === expected ? parts : null;
};

export const getCompositeIdPrefix = (id: ID): IDPrefixes | undefined => {
  const prefix = id.split(SEPARATOR)[0];
  return Object.values(IDPrefixes).includes(prefix as IDPrefixes)
    ? (prefix as IDPrefixes)
    : undefined;
};

export const hasCompositeIdPrefix = (id: ID, expected: IDPrefixes): boolean =>
  id.startsWith(`${expected}${SEPARATOR}`);
